import apiClient from "../Util/ApiClient";

export default class ProjectApi {

    static filter = (query = {}) => {
        return apiClient.get('/projects', {
            params: query
        });
    };
}